import React from "react";
import { useDispatch } from "react-redux";
import { Trash2 } from "lucide-react";
import { deleteKnowledge, getKnwoledge } from "../../actions/knowledge.actions";

const DeleteCard = ({ id }) => {
  const dispatch = useDispatch();

  const deleteQuote = () =>
    dispatch(deleteKnowledge(id)).then(() => dispatch(getKnwoledge()));

  return (
    <div
      className="delete-card-icon"
      onClick={(e) => {
        e.preventDefault();
        if (window.confirm("Voulez-vous supprimer ce tutoriel ?")) {
          deleteQuote();
        }
      }}
    >
      <Trash2 size={15} />
    </div>
  );
};

export default DeleteCard;
